import { Button, Col, Form, Input, Row, notification } from "antd";
import React, { useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";

const NewLogisticsClient = ({ history }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const createClient = async (data) => {
		const user = {
			name: data.name,
		};

		try {
			let url = api + "/logistics/client/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, user);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					history.push("/logistics/destination/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to create destination"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		createClient(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" loading={loading}>
					Create
				</Button>
			</Form>
		);
	};

	return (
		<Layout title="New Client" description="Create new Client" type="small">
			{contextHolder}
			<CustomForm />
		</Layout>
	);
};

export default NewLogisticsClient;
